(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    ;(function () {
    const searchOpenToggle = document.getElementById('search-open')
    const searchInput = searchOpenToggle?.closest('search')?.querySelector(
      '.header-search-input',
    )
    const loadingEl = document.querySelector('.header-search-loading')
    const noResultsEl = document.querySelector('.header-search-no-results')
    const resultsList = document.querySelector('.header-search-list')
    const seeAllLink = document.querySelector('.header-search-see-all')
    const clearButton = document.querySelector('#search-clear')

    let debounceTimer

    function debounce(fn, delay) {
      clearTimeout(debounceTimer)
      debounceTimer = setTimeout(fn, delay)
    }

    function showLoading() {
      loadingEl.classList.remove('hidden')
      noResultsEl.classList.add('hidden')
      resultsList.innerHTML = ''
    }

    function hideLoading() {
      loadingEl.classList.add('hidden')
    }

    function showNoResults() {
      noResultsEl.classList.remove('hidden')
    }

    function clearResults() {
      resultsList.innerHTML = ''
      noResultsEl.classList.add('hidden')
      loadingEl.classList.add('hidden')
      seeAllLink.classList.add('hidden')
      clearButton.setAttribute('hidden', true)
    }

    function renderResults(resources, query) {
      resultsList.innerHTML = ''

      const products = resources.results?.products || []
      const articles = resources.results?.articles || []
      const pages = resources.results?.pages || []

      const allResults = [...products, ...articles, ...pages]
      const totalCount =
        (resources.results?.products_count || 0) +
        (resources.results?.articles_count || 0) +
        (resources.results?.pages_count || 0)

      if (allResults.length === 0) {
        showNoResults()
        seeAllLink.classList.add('hidden')
        return
      }

      seeAllLink.href = `/search?q=${encodeURIComponent(query)}`
      seeAllLink.classList.remove('hidden')

      allResults.forEach((item) => {
        const li = document.createElement('li')
        li.className = 'px-4'

        const link = document.createElement('a')
        link.href = item.url
        link.className = 'relative flex items-center gap-3 hover:before:absolute hover:before:-inset-2 hover:before:bg-vh-navy/10 hover:before:-z-1 hover:before:rounded'

        if (item.featured_image?.url || item.image) {
          const img = document.createElement('img')
          img.src = (item.featured_image?.url || item.image) + '&width=160'
          img.alt = item.title
          img.className = 'size-[80px] shrink-0 aspect-square object-cover rounded overflow-clip text-transparent'
          link.appendChild(img)
        }

        const textContainer = document.createElement('div')
        textContainer.className = 'flex flex-col'

        const title = document.createElement('span')
        title.className = 'text-sm font-light text-vh-navy'
        title.textContent = item.title
        textContainer.appendChild(title)

        if (item.price) {
          const price = document.createElement('span')
          price.className = 'text-xs text-vh-navy/50'
          const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
          })
          price.textContent = formatter.format(item.price)
          textContainer.appendChild(price)
        }

        link.appendChild(textContainer)
        li.appendChild(link)
        resultsList.appendChild(li)
      })
    }

    async function performSearch(query) {
      showLoading()

      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(
            query,
          )}&resources[type]=product,article,page&resources[limit]=5`,
        )
        const data = await response.json()
        hideLoading()
        renderResults(data.resources, query)
      } catch (error) {
        hideLoading()
        console.error('Search failed:', error)
      }
    }

    searchInput.addEventListener('input', (e) => {
      const query = e.target.value.trim()

      if (query.length < 2) {
        clearResults()
        return
      }

      clearButton.removeAttribute('hidden')
      debounce(() => performSearch(query), 1000)
    })

    clearButton.addEventListener('click', () => {
      searchInput.value = ''
      clearResults()
    })

    searchOpenToggle?.addEventListener('change', () => {
      if (searchOpenToggle.checked) {
        searchInput?.focus()
      }
    })
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    ;(function () {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

    function setup(root) {
      const slides = Array.from(root.querySelectorAll('[data-slide]'))
      const dots = Array.from(root.querySelectorAll('[data-dot]'))
      if (slides.length < 2) return

      const interval = Number(root.dataset.interval) || 5000
      let current = 0
      let timer = null
      let paused = false

      function show(index, direction) {
        const next = (index + slides.length) % slides.length
        if (next === current) return

        const dir = direction || (next > current ? 1 : -1)
        const outgoing = slides[current]
        const incoming = slides[next]

        // Park the incoming slide off-screen on the entry side without animating
        incoming.classList.add('transition-none')
        incoming.dataset.position = dir > 0 ? 'next' : 'prev'
        void incoming.offsetWidth
        incoming.classList.remove('transition-none')

        incoming.dataset.position = 'active'
        outgoing.dataset.position = dir > 0 ? 'prev' : 'next'

        slides.forEach((slide, i) => {
          slide.setAttribute('aria-hidden', i === next ? 'false' : 'true')
        })
        dots.forEach((dot, i) => {
          dot.setAttribute('aria-selected', i === next ? 'true' : 'false')
        })

        current = next
      }

      function stop() {
        clearInterval(timer)
        timer = null
      }

      function start() {
        stop()
        if (paused || reduceMotion.matches || document.hidden) return
        timer = setInterval(() => show(current + 1, 1), interval)
      }

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          show(i)
          start()
        })
      })

      root.addEventListener('mouseenter', () => {
        paused = true
        stop()
      })
      root.addEventListener('mouseleave', () => {
        paused = false
        start()
      })
      root.addEventListener('focusin', () => {
        paused = true
        stop()
      })
      root.addEventListener('focusout', (event) => {
        if (root.contains(event.relatedTarget)) return
        paused = false
        start()
      })

      // Touch swipe (mobile): horizontal drag moves to the prev/next slide,
      // vertical drags are left alone so the page still scrolls
      const track = root.querySelector('.hero-slideshow-track') || root
      const threshold = 40
      let touchStartX = 0
      let touchStartY = 0
      let touching = false

      track.addEventListener(
        'touchstart',
        (event) => {
          if (event.touches.length !== 1) return
          touching = true
          touchStartX = event.touches[0].clientX
          touchStartY = event.touches[0].clientY
          stop()
        },
        { passive: true }
      )

      track.addEventListener(
        'touchend',
        (event) => {
          if (!touching) return
          touching = false
          const touch = event.changedTouches[0]
          const dx = touch.clientX - touchStartX
          const dy = touch.clientY - touchStartY
          if (Math.abs(dx) > threshold && Math.abs(dx) > Math.abs(dy)) {
            show(dx < 0 ? current + 1 : current - 1, dx < 0 ? 1 : -1)
          }
          start()
        },
        { passive: true }
      )

      track.addEventListener('touchcancel', () => {
        touching = false
        start()
      })

      document.addEventListener('visibilitychange', start)
      reduceMotion.addEventListener('change', start)

      start()
    }

    document.querySelectorAll('[data-hero-slideshow]').forEach(setup)
  })()
  } catch(e) { console.error(e); }
})();

})();
